import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import {
  AcceptIdeaCommitteeInput,
  AcceptIdeaGQL,
  AcceptIdeaInput,
  ActionStatusGQL,
  ApprovedIdeaGQL,
  ApproveIdeaExpectationsInput,
  ApproveIdeaInput,
  AwardIdeaGQL,
  Challenge,
  Committee,
  CommitteesGQL,
  CreateIdeaConclusionGQL,
  CreateIdeaConclusionIdeaInput,
  CreateIdeaConclusionInput,
  DefaultMessage,
  DenyIdeaGQL,
  GetChallengesByLanguageAllGQL,
  GetChallengesByLanguageAllQuery,
  GetIdeaQuery,
  GetSustainabilitiesGQL,
  Idea,
  IdeaConclusion,
  RemoveFileGQL,
  ReproveIdeaGQL,
  UpdateIdeaCommitteeGQL,
  ReproveIdeaInput,
  Sustainability,
  TranslateIdeaChallengeInput,
  TranslateIdeaExpectationInput,
  TranslateIdeaGQL,
  TranslateIdeaInput,
  UpdateIdeaCommitteeInput,
  UpdateIdeaConclusionGQL,
  UpdateIdeaConclusionInput,
  UpdateIdeaImplementationGQL,
  UpdateIdeaImplementationInput,
  User,
  ValidateApproveGQL,
  ValidateApproveQuery,
  ConcludeIdeaInput,
  CreateIdeaInput,
  CreateIdeaGQL,
  GetUnitiesGQL,
  SustainabilityKaizen,
  Area,
  Unity,
} from "../../../generated/graphql";

import {
  CommentKaizen,
  File,
  ItemListProps,
  Line,
  TasksProps,
  UpdateIdeaKaizen,
  UpdateIdeaKaizenGQL,
} from "../../../generated/graphql/ideaKaizen.graphql";

import { QueryRef } from "apollo-angular";
import { UserService } from "../../service/user.service";
import { AnimationOptions } from "ngx-lottie";
import moment from "moment";
import {
  GetIdeaKaizenGQL,
  GetIdeaKaizenQuery,
  IdeaKaizen,
  UpdateIdeaKaizenInput,
} from "src/generated/graphql/ideaKaizen.graphql";
import { environment } from "src/environments/environment";
import { GetIdeaKaizenCanManageFilesGQL } from "src/generated/graphql/idea-kaizen/get-idea-kaizen-can-manage-files.graphql";
import { HttpClient } from "@angular/common/http";
import { FrameProps } from "src/app/util/frames-and-lines";
import { ideaKaizenAuthorsProps } from "src/app/util/authors";
import { IDropSettings } from "../my-list/interfaces/drop-settings.interface";

declare var $: any;

interface KaizenFileItem {
  id: string;
  fileName?: string;
  originalName?: string;
  createdAt?: string;
}

@Component({
  selector: "app-my-list-detail-kaizen",
  templateUrl: "./my-list-detail-kaizen.component.html",
  styleUrls: ["./my-list-detail-kaizen.component.scss"],
})
export class MyListDetailKaizenComponent
  extends BaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  step = 1;
  user: User = new User();
  paramId = null;
  getIdeaQuery: QueryRef<GetIdeaQuery>;
  getIdeaKaizenQuery: QueryRef<GetIdeaKaizenQuery>;
  validateApproveQuery: QueryRef<ValidateApproveQuery>;
  resultApprove: DefaultMessage = new DefaultMessage();
  ideaKaizen: IdeaKaizen;
  isIdeaKaizen: boolean = false;
  committees: Committee[] = [];
  listUnity: Unity[] = [];
  sustainabilities: Sustainability[] = [];
  acceptIdeaInput: AcceptIdeaInput = new AcceptIdeaInput();
  concludeIdeaInput: ConcludeIdeaInput = new ConcludeIdeaInput();
  committeeId: string;
  committeeUpdate: string;
  updateIdeaCommitteInput: UpdateIdeaCommitteeInput =
    new UpdateIdeaCommitteeInput();
  modelTag: string;
  approveIdea: Idea = new Idea();
  ideaConclusion: IdeaConclusion = new IdeaConclusion();
  reproveIdeaInput: ReproveIdeaInput = new ReproveIdeaInput();
  actionStatus: string[] = [];
  validateStatus: boolean;

  file: File = null;
  listFiles = [];
  isUpload = false;

  culture: string;

  getChallengeAllQuery: QueryRef<GetChallengesByLanguageAllQuery>;

  challengeResult: Challenge[] = [];

  translateIdeaInputBR: TranslateIdeaInput = new TranslateIdeaInput();
  translateIdeaInputES: TranslateIdeaInput = new TranslateIdeaInput();

  challengeIdBR: string;
  challengeIdES: string;

  financialVoteDescription: string;
  productivityVoteDescription: string;
  sustainabilityVoteDescription: string;

  accessAnimation: AnimationOptions = {
    path: "/assets/lottie/trophy.json",
    renderer: "svg",
    autoplay: true,
    loop: true,
  };

  productivityVote = "";
  productivityVotes = [
    { id: "not attend", value: 0 },
    { id: "parctially attends", value: 10 },
    { id: "attend", value: 15 },
    { id: "overcomes", value: 21 },
  ];

  sustainabilityVote = "";
  sustainabilityVotes = [
    { id: "not attend", value: 0 },
    { id: "parctially attends", value: 5 },
    { id: "attend", value: 9 },
    { id: "overcomes", value: 15 },
  ];

  financialVote = "";
  financialVotes = [
    { id: "not attend", value: 0 },
    { id: "parctially attends", value: 12 },
    { id: "attend", value: 21 },
    { id: "overcomes", value: 31 },
  ];

  points = [
    {
      min: 1,
      max: 12,
      value: 984.4,
      taxValue: 68.91,
      equip: 1476.6,
      taxEquip: 103.36,
    },
    {
      min: 13,
      max: 27,
      value: 2035.5,
      taxValue: 142.49,
      equip: 3053.25,
      taxEquip: 213.73,
    },
    {
      min: 28,
      max: 37,
      value: 3438.5,
      taxValue: 240.7,
      equip: 5157.75,
      taxEquip: 361.04,
    },
    {
      min: 38,
      max: 52,
      value: 4853.0,
      taxValue: 339.71,
      equip: 7279.5,
      taxEquip: 509.57,
    },
    {
      min: 53,
      max: 99,
      value: 6325.0,
      taxValue: 442.75,
      equip: 9487.5,
      taxEquip: 664.13,
    },
  ];

  status = [
    { value: "received", name: "Recebida" },
    { value: "analysis", name: "A fazer" },
    { value: "denial", name: "Reprovar" },
    { value: "approved", name: "Aprovada" },
    { value: "awarded", name: "Concluida" },
    { value: "denied", name: "Reprovada" },
  ];

  todoList: ItemListProps[] = [
    {
      id: "1",
      text: "Entender a ideia",
      completed: false,
      resp: "",
      term: "",
      finishedIn: "",
      detailsVisible: false,
      done: "",
    },
    {
      id: "2",
      text: "Realizar orçamento",
      completed: false,
      resp: "",
      term: "",
      finishedIn: "",
      detailsVisible: false,
      done: "",
    },
    {
      id: "3",
      text: "Implementar",
      completed: false,
      resp: "",
      term: "",
      finishedIn: "",
      detailsVisible: false,
      done: "",
    },
    {
      id: "4",
      text: "treinar a equipe",
      completed: false,
      resp: "",
      term: "",
      finishedIn: "",
      detailsVisible: false,
      done: "",
    },
    {
      id: "5",
      text: "Adicionar um item",
      completed: false,
      resp: "",
      term: "",
      finishedIn: "",
      detailsVisible: false,
      done: "",
    },
  ];

  dropSettings: IDropSettings = {
    singleSelection: false,
    idField: "id",
    textField: "type",
    selectAllText: "Marcar todos",
    unSelectAllText: "Desmarcar todos",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  listStatusItems: SustainabilityKaizen[] = [];
  approveIdeaInput: ApproveIdeaInput = new ApproveIdeaInput();
  ApproveIdeaExpectationsInput: ApproveIdeaExpectationsInput =
    new ApproveIdeaExpectationsInput();

  modelSonsBR: Idea = new Idea();
  modelSonsES: Idea = new Idea();
  model: CreateIdeaInput = new CreateIdeaInput();

  tags: boolean;
  goCommitte: boolean;
  whichCommitee: boolean;
  reproveCommitte: boolean;
  aproveonAnalysis: boolean;
  finalizeAction: boolean;
  finishAwards: boolean;
  editAction: boolean;
  definitionCommitte: boolean;
  concludeIdea: boolean;

  updateIdeaKaizenInput: UpdateIdeaKaizenInput = new UpdateIdeaKaizenInput();
  modelItem: ItemListProps = new ItemListProps();

  imageVisible: boolean = false;
  ideaDate: string = "";
  bucketUrl: string = "";
  imageId: string = "";
  progress: number = 0;
  todoTotal: number = 0;
  todoCount: number = 0;
  todoDivision: number = 0;
  commentsIsVisible: boolean = false;
  comment: string;
  comments: Array<{}>;
  winnings: boolean = false;
  resp: string;
  term: string;

  tasks: TasksProps[] = [];
  lines: Line[];

  // todos os anexos ativos (idea-kaizen-files); a imagem do cartão fica em bucketUrl
  kaizenFiles: KaizenFileItem[] = [];
  // admin pode adicionar/remover anexos (decidido pela API, em qualquer status)
  canManageFiles = false;

  registrationDate: string;
  conclusionDate: string;
  initialDate: string;
  buttonAproveDisabled: boolean = true;

  isPossibleDeleteComment: boolean = false;

  problem: string;
  solution: string;

  financial: number;
  productivity: number;
  sustainability: number;

  ideaStatus: string;
  ideaUnity: string;
  ideaAuthors: ideaKaizenAuthorsProps[] = [];
  ideaFrame: string;
  ideaLine: string;
  showPlaceholderFinishedInText: boolean;
  showPlaceholderTermText: boolean;

  datePicker;

  isPossibleEditFrame: boolean = true;
  isIdeaClic: boolean = false;
  isPossibleViewOtherAuthors: boolean = false;
  tableOfAuthorsIsVisible: boolean = false;

  frames;

  constructor(
    public router: Router,
    public loading: NgxSpinnerService,
    public route2: ActivatedRoute,
    public userService: UserService,
    private getIdeaKaizenGQL: GetIdeaKaizenGQL,
    private getIdeaKaizenCanManageFilesGQL: GetIdeaKaizenCanManageFilesGQL,
    private committeesGQL: CommitteesGQL,
    private getSustainabilitiesGQL: GetSustainabilitiesGQL,
    private validateApproveGQL: ValidateApproveGQL,
    private acceptIdeaGQL: AcceptIdeaGQL,
    private approvedIdeaGQL: ApprovedIdeaGQL,
    private createIdeaConclusionGQL: CreateIdeaConclusionGQL,
    private translateIdeaGQL: TranslateIdeaGQL,
    private getChallengesByLanguageAllGQL: GetChallengesByLanguageAllGQL,
    private awardIdeaGQL: AwardIdeaGQL,
    private updateIdeaImplementationGQL: UpdateIdeaImplementationGQL,
    private updateIdeaConclusionGQL: UpdateIdeaConclusionGQL,
    private reproveIdeaGQL: ReproveIdeaGQL,
    private createIdeaGQL: CreateIdeaGQL,
    private UpdateIdeaCommitteeGQL: UpdateIdeaCommitteeGQL,
    private UpdateIdeaKaizenGQL: UpdateIdeaKaizenGQL,
    private denyIdeaGQL: DenyIdeaGQL,
    private actionStatusGQL: ActionStatusGQL,
    private removeFileGQL: RemoveFileGQL,
    public unitiesGQL: GetUnitiesGQL,
    private http: HttpClient,
    public translate: TranslateService,
  ) {
    super(router, loading, translate);
  }

  ngOnInit() {
    this.userService.user.subscribe({
      next: (data) => {
        this.user = data as User;
        this.userProfile();
      },
      error: (err) => super.onError(err),
    });

    this.route2.params.subscribe((url: { id: string; code: string }) => {
      this.getIdeaKaizen(url);
      this.getCanManageFiles(url.id);
    });

    this.getCommittees();
    this.getAllFrames();
    this.getAllLines();
    this.actionListUnity();
    this.datePicker = new Date().toISOString().split("T")[0];
  }

  reloadScreen() {
    location.reload();
  }

  ideaKaizenMessage(typeMessage?: string, error?: any) {
    switch (typeMessage) {
      case "ideaSuccess":
        this.showMessage(
          "Sucesso!",
          this.translate.instant("ideaSuccess"),
          "success",
        );
        break;
      case "transferIdeaSuccess":
        this.showMessage(
          "Sucesso!",
          this.translate.instant("transferIdeaKaizen"),
          "success",
        );
        break;
      case "imageError":
        this.showMessage("Atenção", this.translate.instant("imageError"));
        break;

      case "commentSuccess":
        this.showMessage(
          this.translate.instant("success"),
          this.translate.instant("commentSuccess"),
          "success",
        );
        break;

      case "commentSuccess2":
        this.showMessage(
          this.translate.instant("success"),
          this.translate.instant("commentSuccess2"),
          "success",
        );
        break;

      case "commentError":
        this.showMessage("Atenção", this.translate.instant("commentError"));
        break;

      case "commentError2":
        this.showMessage("Atenção", this.translate.instant("commentError2"));
        break;

      case "commentError3":
        if (error) {
          this.showMessage(
            "Atenção",
            `${this.translate.instant("commentError3")}: ${error.message ? error.message : error}`,
          );
        }
        break;

      case "commentError4":
        if (error) {
          this.showMessage(
            "Atenção",
            `${this.translate.instant("commentError4")}: ${error.error.message ? error.message : error}`,
          );
        }
        break;

      case "saveItemError":
        if (error) {
          this.showMessage(
            "Atenção",
            `${this.translate.instant("saveItemError")}: ${error.message ? error.message : error}`,
          );
        }
        break;

      case "saveItemSuccess":
        this.showMessage(
          this.translate.instant("success"),
          this.translate.instant("saveItemSuccess"),
          "success",
        );
        break;

      case "deleteItemSuccess":
        this.showMessage(
          this.translate.instant("success"),
          this.translate.instant("deleteItemSuccess"),
          "success",
        );
        break;

      case "deleteItemError":
        if (error) {
          this.showMessage(
            "Atenção",
            `${this.translate.instant("deleteItemError")}: ${error.message ? error.message : error}`,
          );
        }
        break;

      case "resultSuccess":
        this.showMessage(
          this.translate.instant("success"),
          this.translate.instant("resultSuccess"),
          "success",
        );
        break;

      default:
        break;
    }
  }

  verifyItemsCompletedInList(initialLoading?: boolean) {
    this.todoDivision = 100 / this.tasks?.length;
    this.progress = 0;
    this.todoCount = 0;
    this.tasks.forEach((item) => {
      if (
        initialLoading &&
        item.task &&
        item.deadline &&
        item.responsible &&
        item.finishedIn
      ) {
        item.completed = true;
        item.done = "done";
      }
      this.progress += item.completed ? this.todoDivision : 0;
      this.progress = Math.max(this.progress, 0);

      this.todoCount += item.completed ? 1 : 0;
      this.todoCount = Math.max(this.todoCount, 0);
    });
    this.todoTotal = this.tasks?.length;
  }

  getAllTasks(id: string) {
    this.http.get(`${environment.base_url}/idea-kaizen-task/${id}`).subscribe(
      (response) => {
        this.tasks = (response as TasksProps[]).map((item) => {
          return {
            ...item,
            deadline: item.deadline ? item.deadline.split("T")[0] : null,
            finishedIn: item.finishedIn ? item.finishedIn.split("T")[0] : null,
            done: "",
            detailsVisible: false,
          };
        });
        this.verifyItemsCompletedInList(true);
      },
      () => {},
    );
  }

  getAllLines() {
    this.http
      .get<Line[]>(`${environment.base_url}/line`)
      .subscribe((response: Line[]) => {
        this.lines = response.sort((a, b) => a.name?.localeCompare(b.name));
      });
  }

  async getIdeaKaizen(url) {
    this.isIdeaKaizen = true;
    this.paramId = url.id;
    this.loading.show();
    this.getIdeaKaizenQuery = this.getIdeaKaizenGQL.watch({ id: url.id });
    this.getIdeaKaizenQuery.valueChanges.subscribe(
      ({ data }) => {
        this.ideaKaizen = new IdeaKaizen();
        this.ideaKaizen = data.getIdeaKaizen as IdeaKaizen;
        this.ideaAuthors = this.ideaKaizen?.authors;
        this.isPossibleViewOtherAuthors = this.ideaAuthors?.length > 0;

        this.validateStatus = this.handlerStatus();

        this.ideaStatus = this.ideaKaizen?.status;
        this.ideaUnity = this.ideaKaizen?.unity?.id;

        this.ideaLine = this.ideaKaizen?.line?.id;
        this.ideaFrame = this.ideaKaizen?.frame?.id;
        this.isIdeaClic = this.ideaKaizen?.code.toLowerCase().includes("i");
        this.isPossibleEditFrame =
          this.ideaKaizen?.frame?.name
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") === "nao especificado"
            ? false
            : true;

        Promise.all([
          this.getAllTasks(this.ideaKaizen?.id),
          this.getAllFiles(this.ideaKaizen?.id),
          this.getAllComments(this.ideaKaizen?.id),
        ]);

        this.financial = this.ideaKaizen.financialGain;
        this.productivity = this.ideaKaizen.productivityGain;
        this.sustainability = this.ideaKaizen.sustainabilityGain;

        this.buttonAproveIsDisabled();

        this.loading.hide();
      },
      (error) => {
        super.onError(error);
        this.router.navigate(["/my-list-kaizen"]);
      },
    );
  }

  async getIdeaKaizenData(ideaKaizenId) {
    try {
      this.loading.show();

      const data = await new Promise((resolve) => {
        const subscription = this.getIdeaKaizenGQL
          .watch({ id: ideaKaizenId })
          .valueChanges.subscribe(
            ({ data }) => {
              resolve(data);
              subscription.unsubscribe(); //
              this.ideaKaizen = new IdeaKaizen();
              this.ideaKaizen = data.getIdeaKaizen as IdeaKaizen;
              this.loading.hide();
            },
            (error) => {
              super.onError(error);
            },
          );
      });
    } catch (error) {
      super.onError(error);
    }
  }

  getAllFrames() {
    this.http.get(`${environment.base_url}/frame`).subscribe(
      (response: FrameProps[]) => {
        this.frames = response
          .sort((a, b) => a.name?.localeCompare(b.name))
          .map((item) => {
            return {
              id: item.id,
              name: item.name,
            };
          });
      },
      (error) => {
        super.onError(error);
      },
    );
  }

  async transferToIdeaClic() {
    await this.getIdeaKaizenData(this.paramId);

    this.model = {
      areaExtensionLine: this.ideaKaizen.areaExtensionLine || "0000",
      areaResponsible: this.ideaKaizen.areaResponsible || "A definir",
      authorName: this.ideaKaizen.authorName || "",
      authors: this.ideaKaizen.authors || [
        { re: this.ideaKaizen.re, name: this.ideaKaizen.authorName },
      ],
      challenge: this.ideaKaizen.challenge || {
        id: "1397c787-a51b-4692-9fa8-a3cadfbefc05",
        type: "standard",
        language: "pt-BR",
      },
      contactHour: this.ideaKaizen.contactHour || "",
      costCenter: this.ideaKaizen.costCenter || "000",
      country: this.ideaKaizen.country || {
        id: "7b72084f-5443-49b3-9fc2-41278f290aa9",
      },
      description:
        this.ideaKaizen.description ||
        `Problema - ${this.ideaKaizen.problem ?? ""} Possível Solução - ${this.ideaKaizen.solution ?? ""}`,
      document: this.ideaKaizen.document || "00000000000",
      email: this.ideaKaizen.email || "seis.sigma@eurofarma.com",
      managerName: this.ideaKaizen.managerName || "A definir",
      phone: this.ideaKaizen.phone || "00000000000",
      phoneExtensionLine: this.ideaKaizen.phoneExtensionLine || "",
      productiveDescription: this.ideaKaizen.productiveDescription || "",
      productiveEquipament: this.ideaKaizen.productiveEquipament || false,
      re: this.ideaKaizen.re,
      role: this.ideaKaizen.role || "A definir",
      title: this.ideaKaizen.title || "",
      turn: this.ideaKaizen.turn || "A definir",
      unity: this.ideaKaizen.unity || {
        id: "e600c1a6-0012-4a68-88ca-1b70fb17b621",
      },
      code: this.ideaKaizen.code || "",
    };

    this.model.authors.forEach((item) => {
      delete item["__typename"];
    });

    delete this.model.unity["__typename"];

    try {
      await this.createIdeaGQL.mutate({ data: this.model }).toPromise();
      return true;
    } catch (err) {
      super.onError(err);
      return false;
    }
  }

  updateStatus() {
    this.updateIdeaKaizen({ status: this.ideaStatus });
    this.ideaKaizenMessage("ideaSuccess");
  }

  updateUnity() {
    this.updateIdeaKaizen({ unity: { id: this.ideaUnity } });
    this.ideaKaizenMessage("ideaSuccess");
  }

  updateFrame() {
    this.updateIdeaKaizen();
    this.ideaKaizenMessage("ideaSuccess");
  }

  updateLine() {
    this.updateIdeaKaizen({
      line: this.ideaLine,
      frame: this.ideaKaizen.frame.id,
    });
    this.ideaKaizenMessage("ideaSuccess");
  }

  updateProblem() {
    this.updateIdeaKaizen({ problem: this.problem });
    this.ideaKaizenMessage("ideaSuccess");
  }

  updateSolution() {
    this.updateIdeaKaizen({ solution: this.solution });
    this.ideaKaizenMessage("ideaSuccess");
  }

  changeName(name: string) {
    switch (name) {
      case "Ideia Pontuada":
        return "Em Execução";
      case "aprovada":
        return "Aprovada";
      case "análise":
        return "A fazer";
      case "premiada":
        return "Concluida";
      case "Reprovada":
        return "Reprovada";
      case "Reprovar":
        return "Reprovar";
      case "Convertido":
        return "Convertido";
      default:
        return "Recebida";
    }
  }

  openModalImage(): void {
    if (this.bucketUrl) {
      this.imageVisible = true;
    } else {
      this.ideaKaizenMessage("imageError");
    }
  }

  closeModalImage(): void {
    this.imageVisible = false;
  }

  itemListIsDone(item: TasksProps, isDone?: boolean): void {
    const itemList = this.tasks?.find((itemList) => itemList.id === item.id);
    isDone !== undefined
      ? (itemList.completed = isDone)
      : (itemList.completed = !itemList?.completed);
  }

  toggleEye(item: ItemListProps) {
    item && (item.detailsVisible = !item.detailsVisible);
  }

  addItem(modelItem: ItemListProps) {
    const arrValidateFields = [
      {
        value: this.modelItem.text,
        text: `${this.translate.instant("Descrição")} <br>`,
      },
    ];

    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha esses campos antes de criar um novo item: <br> ${stringError}`,
      );
      return;
    }

    const data = {
      task: modelItem.text,
      responsible: modelItem.resp,
      deadline: modelItem.term,
      finishedIn: modelItem.finishedIn,
    };

    this.http
      .post(
        `${environment.base_url}/idea-kaizen-task/${this.ideaKaizen.id}`,
        data,
      )
      .subscribe(
        () => {
          this.closeModal("modalAddItemInTodo");
          this.showMessage(
            this.translate.instant("success"),
            this.translate.instant("Tarefa criada com sucesso"),
            "success",
          );
          setTimeout(() => {
            this.reloadScreen();
          }, 1500);
        },
        (error) => {
          this.showMessage(
            "Atenção",
            `Erro ao enviar dados para o servidor: ${error.message ? error.message : error}`,
          );
        },
      );

    this.modelItem.text = "";
    this.modelItem.resp = "";
    this.modelItem.term = "";
    this.modelItem.finishedIn = "";

    this.verifyItemsCompletedInList(true);
  }

  showModalAddItem() {
    super.showModal("modalAddItemInTodo");
  }

  closeAllItems() {
    this.tasks.some((item) => item.detailsVisible === true)
      ? this.tasks.forEach((item) => {
          item.detailsVisible = false;
        })
      : this.tasks.forEach((item) => {
          item.detailsVisible = true;
        });
  }

  toggleComment() {
    this.comments
      ? (this.commentsIsVisible = !this.commentsIsVisible)
      : this.ideaKaizenMessage("commentError");
  }

  toggleWinnings() {
    this.winnings = !this.winnings;
  }

  saveItemList(item: TasksProps) {
    item.task && item.responsible && item.deadline && item.finishedIn
      ? ((item.done = "done"),
        this.itemListIsDone(item, true),
        this.verifyItemsCompletedInList())
      : ((item.done = ""),
        this.itemListIsDone(item, false),
        this.verifyItemsCompletedInList());

    const data = {
      tasks: item.task,
      responsible: item.responsible,
      deadline: item.deadline,
      finishedIn: item.finishedIn,
      completed: item.completed,
    };

    this.http
      .put(`${environment.base_url}/idea-kaizen-task/${item.id}`, data)
      .subscribe(
        (response) => {
          this.ideaKaizenMessage("saveItemSuccess");
        },
        (error) => {
          this.ideaKaizenMessage("saveItemError", error);
        },
      );
  }

  deleteItemList(item: TasksProps) {
    super.confirmMessage(
      "Atenção",
      `Deseja deletar o item: "${item.task}"`,
      () => {
        this.http
          .delete(`${environment.base_url}/idea-kaizen-task/${item.id}`)
          .subscribe(
            (response) => {
              this.ideaKaizenMessage("deleteItemSuccess");
              this.reloadScreen();
            },
            (error) => {
              this.ideaKaizenMessage("deleteItemError", error);
            },
          );
      },
    );
  }

  createComment() {
    const arrValidateFields = [{ value: this.comment, text: "comentário<br>" }];

    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.ideaKaizenMessage("commentError2");
      return;
    }

    this.http
      .post(
        `${environment.base_url}/idea-kaizen-comment/${this.ideaKaizen.id}`,
        { comment: this.comment, userId: this.user.id },
      )
      .subscribe(
        (response) => {
          this.ideaKaizenMessage("commentSuccess");
          this.comment = "";
          this.reloadScreen();
        },
        (error) => {
          this.ideaKaizenMessage("commentError3", error);
        },
      );
  }

  deleteComment(id: string) {
    super.confirmMessage("Atenção", `Deseja deletar esse comentário`, () => {
      this.http
        .delete(`${environment.base_url}/idea-kaizen-comment/${id}`)
        .subscribe(
          (response) => {
            this.ideaKaizenMessage("commentSuccess2");
            this.reloadScreen();
          },
          (error) => {
            this.ideaKaizenMessage("commentError4", error);
          },
        );
    });
  }

  getAllComments(id: string) {
    this.http
      .get(`${environment.base_url}/idea-kaizen-comment/${id}`)
      .subscribe(
        (response: CommentKaizen[]) => {
          this.comments = response.map((item) => {
            return {
              commentId: item.id,
              comment: item?.comment,
              createdAt: this.formatDateComment(item?.createdAt),
              user: {
                id: item?.user?.id,
                name: item?.user?.name,
              },
            };
          });
        },
        (error) => {},
      );
  }

  formatDateComment(createdAt: string): string {
    const months = [
      "janeiro",
      "fevereiro",
      "março",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro",
    ];

    const date = new Date(createdAt);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    return `${day} de ${month} de ${year} às ${hours}:${minutes}`;
  }

  conclude() {
    const arrValidateFields = [];

    this.tasks?.forEach((item) => {
      if (
        !item.task ||
        !item.deadline ||
        !item.responsible ||
        !item.finishedIn ||
        !item.done
      ) {
        arrValidateFields.push({ value: item.done, text: `${item.task} <br>` });
      }
    });

    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha e salve todos os dados desses itens: <br> ${stringError}`,
      );
      return;
    }

    super.confirmMessageKaizen(
      "Atenção",
      "A ideia trouxe resultados financeiros, produtividade ou sustentabilidade?",
      "#FAE100",
      "#032e58",
      async () => {
        this.ideaStatus = "awarded";
        const data = {
          status: "awarded",
          conclusionDate: new Date(),
        };
        this.updateIdeaKaizen({ ...data });

        setTimeout(() => {
          this.router.navigate(["/my-list-kaizen"]);
        }, 1000);
        return;
      },
    );

    this.winnings = true;
  }

  buttonAproveIsDisabled() {
    this.buttonAproveDisabled =
      this.financial && this.productivity && this.sustainability ? false : true;
  }

  getAllFiles(id: string) {
    this.http.get(`${environment.base_url}/idea-kaizen-file/${id}`).subscribe(
      (response: KaizenFileItem[]) => {
        this.kaizenFiles = (response || []).filter((item) =>
          item?.fileName?.includes("idea-kaizen-files"),
        );

        const fileImage = response?.find((item) =>
          item?.fileName?.includes("idea-kaizen-images"),
        );

        if (fileImage?.fileName) {
          this.bucketUrl = environment.bucketUrl.concat(fileImage.fileName);
        }
      },
      () => {},
    );
  }

  getCanManageFiles(id: string) {
    this.getIdeaKaizenCanManageFilesGQL
      .fetch({ id }, { fetchPolicy: "network-only" })
      .subscribe({
        next: ({ data }) => {
          this.canManageFiles = !!data?.getIdeaKaizen?.canManageFiles;
        },
        error: () => {},
      });
  }

  async aproveIdea() {
    this.ideaStatus = "approved";

    const data = {
      status: "approved",
      financialGain: this.financial,
      productivityGain: this.productivity,
      sustainabilityGain: this.sustainability,
      conclusionDate: new Date(),
    };

    this.updateIdeaKaizen({ ...data });
    const result = await this.transferToIdeaClic();
    result && this.ideaKaizenMessage("transferIdeaSuccess");
  }

  saveResultsIdea() {
    const data = {
      financialGain: this.financial,
      productivityGain: this.productivity,
      sustainabilityGain: this.sustainability,
    };

    this.updateIdeaKaizen({ ...data });
    this.ideaKaizenMessage("resultSuccess");
  }

  updateIdeaKaizen(ideaKaizen?: UpdateIdeaKaizen) {
    this.updateIdeaKaizenInput = {
      id: this.ideaKaizen.id,
      frame: this.ideaFrame,
      userId: this.user.id,
      ...ideaKaizen,
    };

    this.UpdateIdeaKaizenGQL.mutate({
      input: this.updateIdeaKaizenInput,
    }).subscribe(
      async ({}) => {},
      (err: unknown) => {
        super.onError(err);
      },
    );
  }

  showPlaceholderFinishedIn(show: boolean): void {
    this.showPlaceholderFinishedInText = show;
  }

  showPlaceholderTerm(show: boolean): void {
    this.showPlaceholderTermText = show;
  }

  modelPtEs() {
    this.modelSonsBR = this.getSon("pt-BR");
    this.modelSonsES = this.getSon("es-ES");
  }

  getSon(language: string) {
    const indexSons = this.ideaKaizen.sons.findIndex(
      (e) => e.challengeLanguage === language,
    );
    if (indexSons !== -1) {
      return JSON.parse(JSON.stringify(this.ideaKaizen.sons[indexSons]));
    } else {
      return JSON.parse(JSON.stringify(this.ideaKaizen));
    }
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    const elModalCommittee = $("#ModalCommittee");
    const elModalRefusal = $("#ModalRefusal");
    const elModalResume = $("#ModalResume");
    if (elModalCommittee[0]) {
      elModalCommittee.remove();
    }
    if (elModalRefusal[0]) {
      elModalRefusal.remove();
    }
    if (elModalResume[0]) {
      elModalResume.remove();
    }
  }

  onChangeExpectation(x: any) {
    x.isSelected = !x.isSelected;
  }

  getCommittees() {
    this.committeesGQL.watch({}).valueChanges.subscribe(({ data }) => {
      this.committees = data.committees as Committee[];
    });
  }

  getSustainabilities() {
    this.getSustainabilitiesGQL.watch({}).valueChanges.subscribe(({ data }) => {
      this.sustainabilities = data.sustainabilities as Sustainability[];
    });
  }

  actionRemoveTag(o: any) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente deletar essa tag?",
      () => {
        this.acceptIdeaInput.tags = this.acceptIdeaInput.tags.filter(
          (item) => item !== o,
        );
      },
    );
  }

  createTag(s: any) {
    if (
      this.isNullOrUndefined(this.modelTag) ||
      this.isNullOrUndefined(this.modelTag.trim())
    ) {
      return;
    }
    this.acceptIdeaInput.tags = !this.isNullOrUndefined(
      this.acceptIdeaInput.tags,
    )
      ? this.acceptIdeaInput.tags
      : [];
    if (this.acceptIdeaInput.tags.some((x) => x === s)) {
      this.showMessage("Atenção", `Já existe uma tag cadastrada.`);
      return;
    }
    this.acceptIdeaInput.tags = !this.isNullOrUndefined(
      this.acceptIdeaInput.tags,
    )
      ? Object.assign([], this.acceptIdeaInput.tags)
      : [];
    this.acceptIdeaInput.tags.push(s);
    this.modelTag = null;
  }

  onAcceptIdea() {
    const arrValidateFields = [
      { value: this.acceptIdeaInput.tags, text: "Tags<br>" },
      { value: this.committeeId, text: "Comitê<br>" },
    ];
    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }
    const acceptIdeaCommitteeInput: AcceptIdeaCommitteeInput = {
      id: this.committeeId,
    };
    this.acceptIdeaInput.id = this.paramId;
    this.acceptIdeaInput.committee = acceptIdeaCommitteeInput;
    this.loading.show();
    this.acceptIdeaGQL.mutate({ input: this.acceptIdeaInput }).subscribe(
      ({ data }) => {
        this.getIdeaQuery.refetch({ id: data.acceptIdea.id });
        this.loading.hide();
        this.showMessage(
          "Sucesso!",
          `Ideia enviada para o comitê com sucesso!`,
          "success",
        );
      },
      (err) => super.onError(err),
    );
  }

  getActionByType(type: string) {
    return this.ideaKaizen.action.filter((e) => e.status === type);
  }

  onAnalysis(id) {
    this.validateApproveGQL.watch({ id }).valueChanges.subscribe(({ data }) => {
      this.resultApprove = data.validateApproveIdea as DefaultMessage;
      if (this.resultApprove.status === 200) {
        this.approveIdea.implementationResume = undefined;
        this.showModal("ModalResume");
        this.approveIdea.premiationDate = moment().format();
        this.setDate("picker-premiationDate", (start, end, label) => {
          this.approveIdea.premiationDate = end.utcOffset(0, true).format();
        });
      } else {
        return;
      }
    });
  }

  onApproved() {
    this.productivityVote = null;
    this.sustainabilityVote = null;
    this.financialVote = null;

    this.ideaConclusion = new IdeaConclusion();
    this.ideaConclusion.prize = 0.0;
    this.financialVoteDescription = this.ideaKaizen?.expectations.find(
      (s) => s.expectation == "finance-admin",
    )?.expectationDescription;
    this.productivityVoteDescription = this.ideaKaizen?.expectations.find(
      (s) => s.expectation == "productive-admin",
    )?.expectationDescription;
    this.sustainabilityVoteDescription = this.ideaKaizen?.expectations.find(
      (s) => s.expectation == "sustainability-admin",
    )?.expectationDescription;
    this.showModal("ModalCommittee");
  }

  onAward() {
    super.confirmMessage("Atenção", "Deseja finalizar a ideia ?", () => {
      this.loading.show();
      this.awardIdeaGQL.mutate({ input: this.paramId }).subscribe(
        ({ data }) => {
          this.getIdeaQuery.refetch({ id: data.awardIdea.id });
          this.loading.hide();
          this.showMessage(
            "Sucesso!",
            `Premiação Concluida com sucesso!`,
            "success",
          );
          this.showModalTranslateESPT(1);
        },
        (err) => super.onError(err),
      );
    });
  }

  clickStep(s: number) {
    this.step = s;
    this.getChanlenge();
  }

  showModalTranslateESPT(x: number) {
    this.step = x;
    super.showModal("modalTranslateESPT");
    this.getChanlenge();
  }

  getChanlenge() {
    if (this.step === 1) {
      this.culture = "pt-BR";
    } else {
      this.culture = "es-ES";
    }
    this.getChallengeAllQuery = this.getChallengesByLanguageAllGQL.watch({
      input: this.culture,
    });
    this.getChallengeAllQuery.valueChanges.subscribe(({ data }) => {
      this.challengeResult = data.getChallengesByLanguageAll as Challenge[];
    });
  }

  ideaTranslate() {
    const arrValidateFields = [
      { value: this.challengeIdBR, text: "Idea Português<br>" },
      { value: this.modelSonsBR.title, text: "Título Português<br>" },
      { value: this.modelSonsBR.description, text: "Descrição Português<br>" },
      {
        value: this.modelSonsBR.productiveDescription,
        text: "Descrição Produtiva Português<br>",
      },
      {
        value: this.modelSonsBR.analysisDescription,
        text: "Descrição de Analise Português<br>",
      },

      { value: this.challengeIdES, text: "Idea Espanhol<br>" },
      { value: this.modelSonsES.title, text: "Título Espanhol<br>" },
      { value: this.modelSonsES.description, text: "Descrição Espanhol<br>" },
      {
        value: this.modelSonsES.productiveDescription,
        text: "Descrição Produtiva Espanhol<br>",
      },
      {
        value: this.modelSonsES.analysisDescription,
        text: "Descrição de Analise Espanhol<br>",
      },
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }
    let translateIdeaExpectationInputBR: TranslateIdeaExpectationInput[] = [];
    this.modelSonsBR.expectations.forEach((e) => {
      translateIdeaExpectationInputBR.push({
        id: e.id,
        expectationDescription: e.expectationDescription,
        expectation: e.expectation,
      });
    });
    const translateIdeaChallengeInputBR: TranslateIdeaChallengeInput = {
      id: this.challengeIdBR,
    };
    this.translateIdeaInputBR = {
      challengeLanguage: "pt-BR",
      challengeId: translateIdeaChallengeInputBR,
      analysisDescription: this.modelSonsBR.analysisDescription,
      description: this.modelSonsBR.description,
      expectation: translateIdeaExpectationInputBR,
      motive: this.modelSonsBR.motive,
      productiveDescription: this.modelSonsBR.productiveDescription,
      title: this.modelSonsBR.title,
      id: this.ideaKaizen.id,
    };

    let translateIdeaExpectationInputES: TranslateIdeaExpectationInput[] = [];
    this.modelSonsES.expectations.forEach((e) => {
      translateIdeaExpectationInputES.push({
        id: e.id,
        expectationDescription: e.expectationDescription,
        expectation: e.expectation,
      });
    });

    const translateIdeaChallengeInputES: TranslateIdeaChallengeInput = {
      id: this.challengeIdES,
    };
    this.translateIdeaInputES = {
      challengeLanguage: "es-ES",
      challengeId: translateIdeaChallengeInputES,
      analysisDescription: this.modelSonsES.analysisDescription,
      description: this.modelSonsES.description,
      expectation: translateIdeaExpectationInputES,
      motive: this.modelSonsES.motive,
      productiveDescription: this.modelSonsES.productiveDescription,
      title: this.modelSonsES.title,
      id: this.ideaKaizen.id,
    };

    this.loading.show();
    this.translateIdeaGQL
      .mutate({ input: [this.translateIdeaInputBR, this.translateIdeaInputES] })
      .subscribe(
        () => {
          this.getIdeaQuery.refetch({ id: this.paramId }).then();
          this.closeModal("modalTranslateESPT");
          this.showMessage(
            "Sucesso",
            `Idea atualizada com sucesso!`,
            "success",
          );
          this.loading.hide();
        },
        (error) => super.onError(error),
      );
  }

  onImplementation() {
    this.approveIdeaInput.sustainability = [];
    this.listStatusItems.forEach((e) => {
      this.approveIdeaInput.sustainability.push({ id: e.id });
    });
    const arrValidateFields = [
      { value: this.approveIdea.implementationResume, text: "Descrição<br>" },
      { value: this.approveIdea.premiationDate, text: "Data da premiação<br>" },
    ];
    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }
    if (super.isNullOrUndefined(this.ideaKaizen.implementationResume)) {
      this.createImplementation();
    } else {
      this.updateImplementation();
    }
  }

  createImplementation() {
    let approveIdeaExpectationsInput: ApproveIdeaExpectationsInput[] = [];

    this.ideaKaizen.expectations.forEach((e) => {
      approveIdeaExpectationsInput.push({
        expectation: e.expectation + "-admin",
        expectationDescription: e.expectationDescription,
      });
    });
    const createIdeaImplementationInput: ApproveIdeaInput = {
      id: this.paramId,
      implementationResume: this.approveIdea.implementationResume,
      analysisFinacialreturn: this.approveIdea.analysisFinacialreturn,
      analysisMachineValue: this.approveIdea.analysisMachineValue,
      analysisManValue: this.approveIdea.analysisManValue,
      analysisSustainability: this.approveIdea.analysisSustainability,
      premiationDate: this.approveIdea.premiationDate,
      sustainability: this.approveIdeaInput.sustainability,
      expectations: approveIdeaExpectationsInput,
    };

    this.loading.show();
    this.approvedIdeaGQL
      .mutate({ input: createIdeaImplementationInput })
      .subscribe(
        ({ data }) => {
          this.actionUploadFile(this.paramId, false);
          this.closeModal("ModalResume");
          this.loading.hide();
          this.showMessage(
            "Sucesso!",
            `Ideia aprovada com sucesso!`,
            "success",
          );
        },
        (err) => super.onError(err),
      );
  }

  updateImplementation() {
    let approveIdeaExpectationsInput: ApproveIdeaExpectationsInput[] = [];

    this.ideaKaizen.expectations.forEach((e) => {
      approveIdeaExpectationsInput.push({
        expectation: e.expectation,
        expectationDescription: e.expectationDescription,
      });
    });
    const updateIdeaImplementationInput: UpdateIdeaImplementationInput = {
      id: this.paramId,
      implementationResume: this.approveIdea.implementationResume,
      analysisFinacialreturn: this.approveIdea.analysisFinacialreturn,
      analysisMachineValue: this.approveIdea.analysisMachineValue,
      analysisManValue: this.approveIdea.analysisManValue,
      analysisSustainability: this.approveIdea.analysisSustainability,
      premiationDate: this.approveIdea.premiationDate,
      sustainability: this.approveIdeaInput.sustainability,
      expectations: approveIdeaExpectationsInput,
    };

    this.loading.show();

    this.updateIdeaImplementationGQL
      .mutate({ input: updateIdeaImplementationInput })
      .subscribe(
        ({ data }) => {
          this.actionUploadFile(this.paramId, false);
          this.closeModal("ModalResume");
          this.loading.hide();
          this.showMessage(
            "Sucesso!",
            `Implantação da idéia alterado com sucesso!`,
            "success",
          );
        },
        (err) => super.onError(err),
      );
  }

  onIdeaConclusion() {
    const arrValidateFields = [
      { value: this.productivityVote, text: "Votação produtividade<br>" },
      { value: this.sustainabilityVote, text: "Votação sustentabilidade<br>" },
      { value: this.financialVote, text: "Votação retorno financeiro<br>" },
    ];

    if (this.financialVote !== "not attend") {
      arrValidateFields.push({
        value: this.financialVoteDescription,
        text: "Descrição Retono Financeiro<br>",
      });
    }
    if (this.sustainabilityVote !== "not attend") {
      arrValidateFields.push({
        value: this.sustainabilityVoteDescription,
        text: "Descrição Sustentabilidade<br>",
      });
    }
    if (this.productivityVote !== "not attend") {
      arrValidateFields.push({
        value: this.productivityVoteDescription,
        text: "Descrição Aumento de Produtividade<br>",
      });
    }

    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }

    this.ideaConclusion.productivityVote = this.productivityVote;
    this.ideaConclusion.sustainabilityVote = this.sustainabilityVote;
    this.ideaConclusion.financialVote = this.financialVote;

    if (this.financialVote === "not attend") {
      this.ideaConclusion.financialVoteDescription = null;
    }
    if (this.sustainabilityVote === "not attend") {
      this.ideaConclusion.sustainabilityVoteDescription = null;
    }
    if (this.productivityVote === "not attend") {
      this.ideaConclusion.productivityVoteDescription = null;
    }

    if (super.isNullOrUndefined(this.ideaConclusion.id)) {
      this.CreateIdeaConclusion();
    } else {
      this.UpdateIdeaConclusion();
    }
  }

  CreateIdeaConclusion() {
    const createIdeaConclusionIdeaInput: CreateIdeaConclusionIdeaInput = {
      id: this.paramId,
    };
    const createIdeaConclusionInput: CreateIdeaConclusionInput = {
      productivityVote: this.ideaConclusion.productivityVote,
      sustainabilityVote: this.ideaConclusion.sustainabilityVote,
      financialVote: this.ideaConclusion.financialVote,
      financialVoteDescription: this.financialVoteDescription,
      productivityVoteDescription: this.productivityVoteDescription,
      sustainabilityVoteDescription: this.sustainabilityVoteDescription,
      prize: this.ideaConclusion.prize,
      points: this.ideaConclusion.points,
      idea: createIdeaConclusionIdeaInput,
    };
    this.loading.show();
    this.createIdeaConclusionGQL
      .mutate({ input: createIdeaConclusionInput })
      .subscribe(
        ({ data }) => {
          this.closeModal("ModalCommittee");
          this.loading.hide();
          this.getIdeaQuery.refetch({ id: this.paramId });
        },
        (err) => super.onError(err),
      );
  }

  UpdateIdeaConclusion() {
    const createIdeaConclusionIdeaInput: CreateIdeaConclusionIdeaInput = {
      id: this.paramId,
    };
    const updateIdeaConclusionInput: UpdateIdeaConclusionInput = {
      id: this.ideaConclusion.id,
      productivityVote: this.ideaConclusion.productivityVote,
      sustainabilityVote: this.ideaConclusion.sustainabilityVote,
      financialVote: this.ideaConclusion.financialVote,
      financialVoteDescription: this.financialVoteDescription,
      productivityVoteDescription: this.productivityVoteDescription,
      sustainabilityVoteDescription: this.sustainabilityVoteDescription,
      prize: this.ideaConclusion.prize,
      points: this.ideaConclusion.points,
      idea: createIdeaConclusionIdeaInput,
    };
    this.loading.show();
    this.updateIdeaConclusionGQL
      .mutate({ input: updateIdeaConclusionInput })
      .subscribe(
        ({ data }) => {
          this.closeModal("ModalCommittee");
          this.getIdeaQuery.refetch({ id: this.paramId });
          this.loading.hide();
        },
        (err) => super.onError(err),
      );
  }

  onModalImplementation() {
    this.approveIdea = new Idea();
    this.listFiles = [];
    this.setDate(
      "picker-premiationDate",
      (_, end) => {
        this.approveIdea.premiationDate = end.utcOffset(0, true).format();
      },
      this.ideaKaizen.premiationDate,
    );
    this.approveIdea = this.ideaKaizen;
    this.listStatusItems = this.ideaKaizen.sustainability;
    this.showModal("ModalResume");
  }

  onEditDefinition() {
    this.ideaKaizen.conclusion = Object.assign({}, this.ideaKaizen.conclusion);
    this.ideaConclusion = this.ideaKaizen.conclusion;
    if (!this.isNullOrUndefined(this.ideaKaizen.conclusion, true)) {
      this.productivityVote = this.ideaKaizen.conclusion.productivityVote;
      this.sustainabilityVote = this.ideaKaizen.conclusion.sustainabilityVote;
      this.financialVote = this.ideaKaizen.conclusion.financialVote;
      this.financialVoteDescription =
        this.ideaKaizen.conclusion.financialVoteDescription;
      this.sustainabilityVoteDescription =
        this.ideaKaizen.conclusion.sustainabilityVoteDescription;
      this.productivityVoteDescription =
        this.ideaKaizen.conclusion.productivityVoteDescription;
    }

    this.showModal("ModalCommittee");
  }

  changeDenialStatus() {
    const idDenialStatus = this.paramId;
    this.denyIdeaGQL.mutate({ id: idDenialStatus }).subscribe(
      ({ data }) => {
        this.closeModal("ModalDenial");
        this.getIdeaQuery.refetch({ id: this.paramId });
        this.loading.hide();
        this.showMessage(
          "Sucesso!",
          `Sua Ideia mudou para reprovada com sucesso!`,
          "success",
        );
      },
      (err) => super.onError(err),
    );
  }

  onReprove(id) {
    if (this.ideaKaizen.status === "analysis") {
      this.showModal("ModalDenial");
    } else {
      this.validateApproveGQL
        .watch({ id })
        .valueChanges.subscribe(({ data }) => {
          this.resultApprove = data.validateApproveIdea as DefaultMessage;
        });
      if (this.resultApprove.status === 200) {
        this.reproveIdeaInput = new ReproveIdeaInput();
        this.showModal("ModalRefusal");
      } else {
        return;
      }
      this.reproveIdeaInput = new ReproveIdeaInput();
      this.showModal("ModalRefusal");
    }
  }

  // UPLOAD FILE MODAL
  handlerUpload(event) {
    const files = event.target.files;
    if (files.length > 0) {
      if (files[0].size > 60000000) {
        super.showMessage(
          this.translate.instant("baseComponent.warningAttention"),
          this.translate.instant("baseComponent.warningMsgUploadFileMaxSize"),
          "info",
        );
        return;
      }
    }
    const reader = new FileReader();
    reader.onload = (file) => {
      this.listFiles.push({ file: files[0], path: file.target.result });
    };
    reader.readAsDataURL(event.target.files[0]);
    this.file = null;
    this.isUpload = false;
  }

  actionUploadFile(id: string, navigator = true) {
    if (this.listFiles.length === 0) {
      this.getIdeaQuery.refetch({ id: this.paramId });
      this.loading.hide();
    }
    this.listFiles.forEach((x, index) => {
      this.userService.upload(x.file, id, "ideaKaizen").subscribe({
        next: (data) => {
          if (this.listFiles.length === index + 1) {
            this.isUpload = true;
            this.loading.hide();
            this.getIdeaQuery.refetch({ id: this.paramId });
            this.listFiles = [];
            if (navigator) {
              this.router.navigate(["/my-list"]);
            }
          }
        },
        error: (err) => super.onError(err),
      });
    });
  }

  calcAward() {
    this.ideaConclusion.prize = 0.0;
    const p =
      this.productivityVote == null
        ? 0
        : this.productivityVotes.find((s) => s.id === this.productivityVote)
            .value;
    const s =
      this.sustainabilityVote == null
        ? 0
        : this.sustainabilityVotes.find((s) => s.id === this.sustainabilityVote)
            .value;
    const f =
      this.financialVote == null
        ? 0
        : this.financialVotes.find((s) => s.id === this.financialVote).value;

    const total = p + s + f;

    const point = this.points.filter((v) => {
      return total >= v.min && total <= v.max;
    });
    this.ideaConclusion.points = total;
    if (point.length !== 0) {
      if (this.ideaKaizen.authors.length + 1 > 1) {
        this.ideaConclusion.prize = point[0].equip;
      } else {
        this.ideaConclusion.prize = point[0].value;
      }
    }
  }

  handlerStatus() {
    switch (this.ideaKaizen.status) {
      case "awarded":
        return false;
      default:
        return true;
    }
  }

  getEnumType() {
    this.actionStatusGQL.watch().valueChanges.subscribe(
      ({ data }) => {
        this.actionStatus = data.actionStatus as string[];
      },
      (error) => this.onError(error),
    );
  }

  onRemoveFileList(i: number) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente deletar esse arquivo?",
      () => {
        this.listFiles.splice(i, 1);
      },
    );
  }

  onRemoveFile(id: string, i: number) {
    super.confirmMessage(
      "Atenção",
      "Deseja realmente deletar esse arquivo?",
      () => {
        this.removeFileGQL.mutate({ id }).subscribe(
          ({ data }) => {
            this.approveIdea.ideafiles.splice(i, 1);
            this.showMessage(
              "Sucesso!",
              "Arquivo deletado com sucesso!",
              "success",
            );
          },
          (error) => super.onError(error),
        );
      },
    );
  }

  onSelectDrop(item: any): void {}

  handlerSustainability(sustainability: Array<Sustainability>) {
    var response = [];
    for (let s of sustainability) {
      const x = this.getTranslate(s.type);
      response.push(x);
    }
    return response.join("|");
  }

  userProfile() {
    switch (this.user.role) {
      case "admin":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "user":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "corporate-manager":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "local-manager":
        this.tags = true;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = true;
        this.aproveonAnalysis = true;
        this.finishAwards = true;
        this.editAction = true;
        this.definitionCommitte = true;
        this.concludeIdea = true;
        break;
      case "committee-member":
        this.tags = false;
        this.whichCommitee = true;
        this.reproveCommitte = true;
        this.goCommitte = true;
        this.finalizeAction = false;
        this.aproveonAnalysis = false;
        this.finishAwards = false;
        this.editAction = false;
        this.definitionCommitte = false;
        this.concludeIdea = true;
        break;
    }
  }

  reproveIdea() {
    const arrValidateFields = [
      { value: this.reproveIdeaInput.motive, text: "Descreva aqui<br>" },
    ];
    const stringError = this.validateField(arrValidateFields);

    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(
        "Atenção",
        `Preencha os campos corretamente: <br> ${stringError}`,
      );
      return;
    }
    this.reproveIdeaInput.id = this.paramId;
    this.reproveIdeaGQL.mutate({ input: this.reproveIdeaInput }).subscribe(
      ({}) => {
        this.closeModal("ModalRefusal");
        this.getIdeaQuery.refetch({ id: this.paramId });
        this.loading.hide();
        this.showMessage("Sucesso!", `Ideia reprovada com sucesso!`, "success");
      },
      (err) => super.onError(err),
    );
  }
  UpdateCommittee() {
    this.updateIdeaCommitteInput = {
      id: this.ideaKaizen.id,
      committe: { id: this.committeeUpdate },
    };

    this.UpdateIdeaCommitteeGQL.mutate({
      input: this.updateIdeaCommitteInput,
    }).subscribe(
      async () => {
        location.reload();
      },
      (err) => super.onError(err),
    );
  }

  actionListUnity() {
    this.unitiesGQL.watch().valueChanges.subscribe(({ data }) => {
      this.listUnity = data.getUnities as Area[];
    });
  }

  toggleVisibilityOfAuthors() {
    this.tableOfAuthorsIsVisible = !this.tableOfAuthorsIsVisible;
  }
}
